export const ToastPlugin = {
  install(Vue) {
    Vue.prototype.$toast = {
      _store: null,
      init(store) {
        this._store = store
      },
      error(message) {
        this._store?.dispatch('toast/error', message)
      },
      success(message) {
        this._store?.dispatch('toast/success', message)
      },
      warning(message) {
        this._store?.dispatch('toast/warning', message)
      },
      info(message) {
        this._store?.dispatch('toast/info', message)
      },
    }
  },
}
